/*
 * @LastEditors: zhanglinju
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from '@/extlib/vue';
import App from './App';
import router from './router';
import yxpapi from '@/extlib/yxpapi';
import { regEmoji, highLightTableMsg } from '@/lib/functional';
import './store/system'; // 注册vuex
import '@/components/common/globalComp'; // 自定义全局组件
import Vant from 'vant';
import 'vant/lib/index.css';
import VueClipboard from 'vue-clipboard2';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
Vue.use(Vant);
Vue.use(VueClipboard);
Vue.use(Viewer);
Viewer.setDefaults({
    Options: {
        inline: true,
        button: false,
        navbar: true,
        title: true,
        toolbar: true,
        tooltip: true,
        movable: true,
        zoomable: true,
        rotatable: true,
        scalable: true,
        transition: true,
        fullscreen: true,
        keyboard: true,
        url: 'data-source',
    },
});
Vue.config.devtools = process.env.NODE_ENV === 'development';
Vue.config.productionTip = false;

let elInput = window.ELEMENT.Input;
let handleInput = elInput.methods.handleInput;
let inputWrap = function (e) {
    e.target.value = regEmoji(e.target.value);
    handleInput.call(this, e);
};
let inputExtend = window.Vue.extend(elInput);
var inputExtendParse = inputExtend.extend({
    methods: {
        handleInput: inputWrap,
    },
});
Vue.prototype.highLightTableMsg = highLightTableMsg;
Vue.component(elInput.name, inputExtendParse);

/* eslint-disable no-new */
new Vue({
    el: '#yxpPageManage',
    store: yxpapi.store,
    router,
    components: { App },
    template: '<App/>',
});
